import { styled } from "@vitality-ds/system";

const DocsBox = styled("div", {
  boxSizing: "border-box",
  fontFamily: "$default",
});

export default DocsBox;
